interface Methode {
    id: string;
    title: string;
    color: string;
    text: string;
    image_kachel: string;
    image_download: string;
}

export const mock_methods: Methode[] = [
    {
        id: "geschaeftsmodell_analyse",
        title: "Geschäftsmodell-Analyse",
        color: "#2514b8",
        text: "Visualisieren und analysieren Sie alle Bausteine Ihres Geschäftsmodells auf einen Blick – für mehr Klarheit und gezielte Weiterentwicklung.",
        image_kachel: "Methoden Kacheln/mk_analyse.jpg",
        image_download: "Methoden Downloads/business_model_canvas_download.jpg"
    },
    {
        id: "werteversprechen",
        title: "Werteversprechen",
        color: "#2514b8",
        text: "Was ist der konkrete Nutzen für Ihre Kund*innen? Schärfen Sie Ihr Werteversprechen (Value Proposition) und positionieren Sie sich klar im Markt.",
        image_kachel: "Methoden Kacheln/mk_werteversprechen.jpg",
        image_download: "Methoden Downloads/werteversprechen_download.jpg"
    },
    {
        id: "trendradar",
        title: "Trendradar",
        color: "#2514b8",
        text: "Erkennen Sie relevante Trends frühzeitig und nutzen Sie sie gezielt als Impulse für neue Produkte, Services oder Geschäftsmodelle.",
        image_kachel: "Methoden Kacheln/mk_trendradar.jpg",
        image_download: "Methoden Downloads/trendrader_download.jpg"
    },
    {
        id: "kernkompetenzen",
        title: "Kernkompetenzen",
        color: "#2514b8",
        text: "Identifizieren Sie, was Ihr Unternehmen wirklich stark macht – und nutzen Sie diese Stärken als Fundament für Innovation.",
        image_kachel: "Methoden Kacheln/mk_kernkompetenz.jpg",
        image_download: "Methoden Downloads/kernkompetenzen_download.jpg"
    },
    {
        id: "stakeholder_map",
        title: "Stakeholder Map",
        color: "#2514b8",
        text: "Wer beeinflusst Ihr Geschäftsmodell – und wen beeinflussen Sie? Verschaffen Sie sich einen Überblick über alle relevanten Akteure*innen.",
        image_kachel: "Methoden Kacheln/km_stakeholder.jpg",
        image_download: "Methoden Downloads/stakeholder_map_download.jpg"
    },
    {
        id: "preisfindung",
        title: "Preisfindung",
        color: "#2514b8",
        text: "Finden Sie den optimalen Preis für Ihr Angebot – strategisch durchdacht, marktgerecht und orientiert an Ihre Kund*innen.",
        image_kachel: "Methoden Kacheln/km_preisfindung.jpg",
        image_download: "Methoden Downloads/preisfindung_download.jpg"
    },
    {
        id: "zielgruppen_definition",
        title: "Zielgruppen-Definition",
        color: "#2514b8",
        text: "Wissen Sie, für wen Sie wirklich Wert schaffen? Definieren Sie Ihre Zielgruppen klar und präzise – für mehr Wirkung und Fokus.",
        image_kachel: "Methoden Kacheln/km_zielgruppe.jpg",
        image_download: "Methoden Downloads/zielgruppen_download.jpg"
    },
    {
        id: "marktkraefte_analyse",
        title: "Marktkräfte-Analyse",
        color: "#2514b8",
        text: "Analysieren Sie Ihre Branche mit dem 5-Kräfte-Modell und erkennen Sie, wo Chancen und Risiken für Ihr Geschäftsmodell liegen.",
        image_kachel: "Methoden Kacheln/km_marktkraefte.jpg",
        image_download: "Methoden Downloads/marktkraefte_download.jpg"
    },
    {
        id: "SWOT_analyse",
        title: "SWOT-Analyse",
        color: "#2514b8",
        text: "Machen Sie sich ein klares Bild Ihrer Stärken, Schwächen, Chancen und Risiken – als Grundlage für strategische Entscheidungen.",
        image_kachel: "Methoden Kacheln/km_swot.jpg",
        image_download: "Methoden Downloads/swot_download.jpg"
    },
    {
        id: "Kundinnenreise",
        title: "Kund*innenreise",
        color: "#2514b8",
        text: "Verstehen Sie die Erlebnisse Ihrer Kund*innen – vom ersten Kontakt bis zur langfristigen Beziehung – und optimieren Sie gezielt deren Journey.",
        image_kachel: "Methoden Kacheln/km_reise.jpg",
        image_download: "Methoden Downloads/kundenreise_download.jpg"
    },
    {
        id: "neue_maerkte",
        title: "Neue Märkte",
        color: "#2514b8",
        text: "Erkunden Sie ungenutzte Potenziale: Mit dieser Methode entdecken Sie neue Zielgruppen, Segmente oder geografische Märkte.",
        image_kachel: "Methoden Kacheln/km_neue.jpg",
        image_download: "Methoden Kacheln/neue_kachel.jpg"
    },
    {
        id: "KMU_innovationsprozess",
        title: "KMU-Innovationsprozess",
        color: "#2514b8",
        text: "Ein strukturierter Fahrplan für kleine und mittlere Unternehmen, um Ideen systematisch in marktfähige Innovationen zu überführen.",
        image_kachel: "Methoden Kacheln/mk_kmu.jpg",
        image_download: "Methoden Downloads/kmu_inno_download.jpg"
    },
];
